import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  // Gig chat state
  selectedGig: {},
  newMessageCounts: {},
  gigMessages: {},
  // DM state
  selectedChat: {},
  newDmMessageCounts: {},
  chatMessages: {},
  activeTab: 'gigs',
};

const chatSlice = createSlice({
  name: 'chat',
  initialState,
  reducers: {
    setUnreadCounts(state, action) {
      const { gig_messages = {}, dm_messages = {} } = action.payload || {};
      state.newMessageCounts = gig_messages;
      state.newDmMessageCounts = dm_messages;
    },

    setSelectedGig(state, action) {
      state.selectedGig = action.payload;
      if (action.payload?.id) {
        state.newMessageCounts[String(action.payload.id)] = 0;
      }
    },

    incrementNewCount(state, action) {
      const gigId = String(action.payload);
      state.newMessageCounts[gigId] = (state.newMessageCounts[gigId] || 0) + 1;
    },

    setSelectedChat(state, action) {
      state.selectedChat = action.payload;
      if (action.payload?.id) {
        state.newDmMessageCounts[String(action.payload.id)] = 0;
      }
    },

    setActiveTab(state, action) {
      state.activeTab = action.payload;
    },

    setChatMessage(state, action) {
      const { chatId, message } = action.payload;
      state.chatMessages[chatId] = message;
    },

    incrementDmCount(state, action) {
      const chatId = String(action.payload);
      state.newDmMessageCounts[chatId] = (state.newDmMessageCounts[chatId] || 0) + 1;
    },
  },
});

export const {
  setUnreadCounts,
  setSelectedGig,
  incrementNewCount,
  setSelectedChat,
  setActiveTab,
  setChatMessage,
  incrementDmCount,
} = chatSlice.actions;

export default chatSlice.reducer;
